// TODO: move to a new file under src/bl/validation/
export const validateEmailWithDomain = (value) => {
  // noinspection RegExpRedundantEscape
  const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-line max-len
  return emailRegex.test(value);
};

// TODO: move to a new file under src/bl/validation/
export const validatePrice = (value) => {
  const regex = /^\d*\.?\d{0,2}$/; // empty, 0, 1 or 2 digits after dot.
  return regex.test(value);
};
